// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {Portal} from 'react-overlays';

function PortalContainer(props) {
    const {children} = props;

    return <Portal>{children}</Portal>;
}

PortalContainer.propTypes = {
    children: PropTypes.node,
};

export default PortalContainer;
